module.exports = __webpack_public_path__ + "img/picto-likes.4c272bbd.svg";